import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import Paragraph from '../../Paragraph/Paragraph';
import Modal from '../../Modal';
import ButtonPrimary from '../../Buttons/Button';
import { TAndCLink } from '../../ReviewElements';
import themeColors from '../../../assets/styles/themeColors';
import { formatDate } from '../../../util/helpers/dateHelpers';

const ButtonGroup = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px 10px;
  align-items: center;
  @media only screen and (max-width: 750px) {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 10px 10px;
    margin-top: auto;
    margin-bottom: 24px;
  }
`;

const StartApplicationLink = styled(TAndCLink)`
  color: ${themeColors.colorTextSecondary};
  font-weight: 600;
`;

const ExistingApplicationModal = ({
  isOpen,
  onClose,
  createdOn,
  createdBy,
  continueApplication,
  startNewApplication,
}) => {
  const { t } = useTranslation();

  return (
    <Modal
      variant="lg"
      isOpen={isOpen}
      onClose={onClose}
      label={t('existingApplication.title')}
      removeCloseIcon
    >
      <Paragraph color={themeColors.colorTextXLLight} mb={10}>
        {t('existingApplication.cta')}
      </Paragraph>
      <Paragraph color={themeColors.colorErrorMessage} mb={28}>
        {t('existingApplication.startNewApplicationNote')}
      </Paragraph>
      <ButtonGroup>
        <ButtonPrimary
          onClick={() => continueApplication()}
          title={t('existingApplication.continueCurrentApplication')}
        />
        <div>
          <StartApplicationLink onClick={() => startNewApplication()}>
            {t('existingApplication.openAccount')}
          </StartApplicationLink>
        </div>
      </ButtonGroup>
      {createdOn && (
        <Paragraph color={themeColors.colorTextSecondary} mt={10} mb={10}>
          {t('existingApplication.startedApplicaton')}
          {formatDate(createdOn)}
          {t('existingApplication.by', {
            owner: createdBy === '' ? 'customer' : createdBy,
          })}
        </Paragraph>
      )}
    </Modal>
  );
};

ExistingApplicationModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  continueApplication: PropTypes.func,
  startNewApplication: PropTypes.func,
  createdOn: PropTypes.string,
  createdBy: PropTypes.string,
};

export default ExistingApplicationModal;
